import React, { useEffect, useRef } from 'react';
import { FlyoutProps } from '@lithos/Flyout';
import { Flyout as FlyoutComponent } from '@lithos';
import { useHotKeysContext } from '../../context/HotKeysContext';

export const Flyout = (props: FlyoutProps) => {
  const { showSearchModal } = useHotKeysContext();
  const prevShowSearchModal = useRef(showSearchModal);

  useEffect(() => {
    if (!prevShowSearchModal.current && showSearchModal) {
      props.setIsOpen(false);
    }
    prevShowSearchModal.current = showSearchModal;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showSearchModal, props.setIsOpen]);

  return <FlyoutComponent {...props} />;
};

export default Flyout;
